import { Device } from 'DeviceUtils';

const getExtensionId = (slug, platform) => `${slug}_extension_${platform}`;

const extendPageReferenceFromExtension = (items, itemToExtend, platformString) => {
    const extension = items.find((item) => {
        // If slug includes desired slug but it is not the same
        if (item.slug.includes(itemToExtend.slug) && item.slug !== itemToExtend.slug) {
            // If item slug is the same as generated extension id in correct format
            if (item.slug === getExtensionId(itemToExtend.slug, platformString)) {
                return true;
            }
        }
        return false;
    });

    if (extension) {
        return {
            ...itemToExtend,
            reference: extension.reference,
            extendedFrom: extension.slug
        };
    }

    return itemToExtend;
};

const filterOutItems = (menuItems, customItems) => {
    const filteredItems = [];
    menuItems.forEach((item) => {
        customItems.forEach((customItem) => {
            if (item.slug === customItem.slug) {
                filteredItems.push(item);
            }
        });
    });

    return filteredItems;
};

const extendMenuItems = (menuItems, customItems = []) => {
    const customizedMenuItems = [...menuItems];
    customizedMenuItems.forEach((item, index) => {
        let menuItem = { ...item };
        // First we need to set parentSlug on menu items which has children
        // (for filter purposes later)
        if (menuItem.items && menuItem.items.length > 0) {
            menuItem.items.map((itemOfMenuItem) => {
                itemOfMenuItem.parentSlug = menuItem.slug;

                return itemOfMenuItem;
            });
        }

        menuItem = extendPageReferenceFromExtension(
            customizedMenuItems,
            menuItem,
            Device.platformString
        );

        customizedMenuItems[index] = menuItem;

        customItems.forEach((customMenuItem) => {
            // Slug is the main identifier of which menu item should be extended
            if (menuItem.slug === customMenuItem.slug) {
                customizedMenuItems[index] = {
                    ...menuItem,
                    ...customMenuItem
                };
                // Extend also nested items
                if (menuItem.items && customMenuItem.items) {
                    // If addNonExtendedItems is set
                    // filter out items that are not extended from custom items
                    if (!customMenuItem.addNonExtendedItems) {
                        menuItem.items = filterOutItems(menuItem.items, customMenuItem.items);
                    }
                    if (menuItem.items.length > 0) {
                        customizedMenuItems[index].items = extendMenuItems(
                            menuItem.items,
                            customMenuItem.items,
                            menuItem.slug
                        );
                    } else {
                        customizedMenuItems[index].items = customMenuItem.items;
                    }
                }
            }
        });
    });

    // Filter out remaining extensions
    return customizedMenuItems.filter((item) => !item.slug.includes('_extension'));
};

export { getExtensionId, extendPageReferenceFromExtension, filterOutItems, extendMenuItems };
